import { call, put, takeLatest } from 'redux-saga/effects'
import { checkLogin } from '../../pages/Login/reducer'
import { getPersisted, restoreSessionCookies, setPersisted } from './helpers'

import { push } from '@lagunovsky/redux-react-router'
import { callApiAsync } from 'services/api/callAPIAsync'
import { getToken, setLoading } from './reducer'

function* isTokenValid() {
    const token = getPersisted('token')
    if (!token) {
        return false
    }

    const { error } = yield call(callApiAsync, 'getTokenInfo')

    return error === null
}

// Cookie is the main source of token data, local storage is just for convenience.
// Local storage could and probably should be replaced by redux state.

function* tokenCallSaga() {
    yield put(setLoading(true))

    // Cookie mohla zmizet, zatímco kopie v localStorage přežila. Obnovit ji ještě před
    // prvním requestem – refresh bez `token` a `x-client` vrátí API_TOKEN_MISSING.
    restoreSessionCookies()

    const havingValidToken = yield isTokenValid()

    const storedToken = getPersisted('token')
    const storedTokenValidity = getPersisted('token_validity')
    const xClient = getPersisted('x-client')

    //if Valid token from previous visit of page
    if (havingValidToken && xClient) {
        // přepsat stejnou hodnotou → posune se Max-Age, session se prodlouží o dalších 30 dní
        setPersisted('token', storedToken)
        if (storedTokenValidity) {
            setPersisted('token_validity', storedTokenValidity)
        }
        yield put(checkLogin())
        yield put(setLoading(false))
        return null
    }

    // Nejdřív zkusit refresh s PŮVODNÍM x-client (BE ho porovnává se session – nesmíme ho měnit před refresh)
    const { data: refreshData, error: refreshError } = yield call(callApiAsync, 'refresh')

    if (refreshData?.token) {
        // Refresh úspěšný - obnovil uživatelskou session
        setPersisted('token', refreshData.token)

        // Pokud BE vrátil i validity, uložit
        if (refreshData.validity) {
            setPersisted('token_validity', refreshData.validity)
        }

        yield put(setLoading(false))
        yield put(checkLogin())
    } else {
        // Refresh selhal - teprve teď vytvořit nový x-client a anonymní session (createToken)
        const uuid = crypto.randomUUID()
        setPersisted('x-client', uuid)

        const { data: tokenData, error: tokenError } = yield call(callApiAsync, 'createToken')

        if (tokenError) {
            console.error(tokenError)
            yield put(setLoading(false))
            yield put(push('/login'))
            return null
        }

        setPersisted('token', tokenData.token)
        setPersisted('token_validity', tokenData.validity)

        yield put(setLoading(false))
        yield put(checkLogin())
    }
}

export default function* tokenSaga() {
    yield takeLatest(getToken.type, tokenCallSaga)
}
